import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/matchCard.css';

import {getText} from '../../../../../../helpers/localization';
import {ASSETS_URL} from '../../../../../../constants/endpoints';
import {toggleBettingTypeButtonsDisplayed} from '../../../../modules/racing/actions/raceCardActions';
import MainMarketsCard from './mainMarketsCard';
import MoreMarketsCard from './moreMarketsCard';

const mapStateToProps = (state, ownProps) => {
    return {isSimpleBetsSelected: state.vpp.isSimpleBetsSelected};
};

class MatchCard extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            isSimpleBetsSelected: storeData.vpp.isSimpleBetsSelected
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                isSimpleBetsSelected: storeData.vpp.isSimpleBetsSelected
            });
        }
    }

    render() {

        let mainMarkets = (<MainMarketsCard id='mainMarkets' store={this.props.store}/>);
        let moreMarkets = (<MoreMarketsCard id='resultCard' store={this.props.store}/>);
        let changeBetsButtonContainer;
        if (this.state.isSimpleBetsSelected) {
            changeBetsButtonContainer = (<div className={style.bettingTypeToogleSlider}
                                              onClick={() => this.props.store.dispatch(toggleBettingTypeButtonsDisplayed())}>
                <div className={style.text}>{getText('MORE', this.props.store).toUpperCase()}</div>
                <div className={style.arrowIconContainer}>
                    <img className={style.arrowIcon} src={`${ASSETS_URL}systemIcons/double_arrow_left.svg`}
                         alt={'chips'}/>
                </div>
                <div className={style.text}>{getText('MARKETS', this.props.store).toUpperCase()}</div>
            </div>);
        } else {
            changeBetsButtonContainer = (<div className={`${style.bettingTypeToogleSlider} ${style.selected}`}
                                              onClick={() => this.props.store.dispatch(toggleBettingTypeButtonsDisplayed())}>
                <div className={style.text}>{getText('MAIN', this.props.store).toUpperCase()}</div>
                <div className={style.arrowIconContainer}>
                    <img className={style.arrowIcon} src={`${ASSETS_URL}systemIcons/double_arrow_right.svg`}
                         alt={'chips'}/>
                </div>
                <div className={style.text}>{getText('MARKETS', this.props.store).toUpperCase()}</div>
            </div>);
        }

        return (<div className={style.raceCardContainer}>
            <div className={style.gameCardContainer}>
                {mainMarkets}
                {moreMarkets}
            </div>
            {changeBetsButtonContainer}
        </div>);
    }
}

export default connect(mapStateToProps)(MatchCard);



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/desktop/modules/football/containers/matchCard.js